import React from 'react';
import Reveal from './Reveal';
import './SpecialProjects.css';

const projects = [
  {
    id: 1,
    title: 'Primeira Exposição Oficial',
    type: 'Exposição de Esculturas',
    status: 'Em Preparação',
    description: 'Varella prepara sua primeira exposição oficial de esculturas em barro — uma coleção que impressionou a comunidade local e demonstra uma técnica autodidata de mais de 30 anos.',
    needs: ['Espaços de exposição', 'Curadores', 'Patrocinadores']
  },
  {
    id: 2,
    title: 'Palco MP3 — 10 Músicas',
    type: 'Música Digital',
    status: 'Disponível',
    description: '10 músicas no Palco MP3, incluindo sambas marcantes como "Rio de Janeiro Cidade Maravilhosa", "Barraco de Zinco", "Forró da Bicharada" e "Malandragem".',
    needs: ['Divulgação', 'Shows e apresentações', 'Parcerias musicais']
  },
  {
    id: 5,
    title: 'Arte Livre',
    type: 'Projeto Infantil',
    status: 'Em Andamento',
    description: 'Projeto educativo que desperta o interesse das crianças pela arte e cultura brasileira por meio de oficinas criativas e atividades interativas.',
    pdf: '/artelivre.pdf',
    needs: ['Parceiros educacionais', 'Patrocinadores', 'Voluntários']
  }
];

const slug = (status) =>
  status.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, '-');

const SpecialProjects = () => {
  const scrollToContact = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="projects" className="special-projects section">
      <div className="container">
        <Reveal>
          <span className="section-eyebrow">Vamos construir juntos</span>
          <h2 className="section-title">Projetos Especiais</h2>
          <p className="section-subtitle">
            Iniciativas que vão além da arte individual, buscando impacto social e cultural.
            Aberto a parceiros, investidores e colaboradores.
          </p>
        </Reveal>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <Reveal key={project.id} className="project-card" delay={(index % 3) * 80}>
              <div className="project-top">
                <span className="project-type">{project.type}</span>
                <span className={`status-badge ${slug(project.status)}`}>{project.status}</span>
              </div>

              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>

              <div className="project-needs">
                <h4>Buscamos</h4>
                <div className="needs-tags">
                  {project.needs.map((need, i) => (
                    <span key={i} className="need-tag">{need}</span>
                  ))}
                </div>
              </div>

              <div className="project-footer">
                {project.pdf && (
                  <a href={project.pdf} target="_blank" rel="noopener noreferrer" className="project-link">
                    Ver projeto (PDF) →
                  </a>
                )}
                <button className="project-btn" onClick={scrollToContact}>
                  Quero participar
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpecialProjects;
